import React, { useEffect, useMemo, useState } from 'react';
import { useBootcamps } from '../../../application/bootcamps/hooks/useBootcamps';
import { Row, Col } from '../../ui/grid';
import ToolbarComponent from '../../ui/section';
import DynamicTable from '../../ui/table2';
import Loader from '../../ui/loader';
import { PrimaryButton } from '../../ui/button';

const BootcampViewPage = (props) => {
    const { getBootcampById, buildStudentsTable, isLoading, safeId } = useBootcamps();
    const [bootcamp, setBootcamp] = useState(null);

    const id = props.match?.params?.id;

    useEffect(() => {
        const load = async () => {
            const data = await getBootcampById(id);
            setBootcamp(data);
        };
        load();
    }, [getBootcampById, id]);

    const table = useMemo(() => buildStudentsTable(bootcamp), [bootcamp, buildStudentsTable]);
    const title = bootcamp?.title || 'Bootcamp';

    const goBack = () => props.history.goBack();
    const goAttendance = () => props.history.push(`/academia/bootcamps/${safeId(bootcamp)}/attendance`);

    return (
        <ToolbarComponent label={title} showBackButton={true} onBackClick={goBack}>
            <Row>
                <Col md={12} className="text-right">
                    {/* Dejar atajo para crear asistencia desde el detalle */}
                    <div style={{ marginBottom: 12 }}>
                        <PrimaryButton
                            text="Crear asistencia"
                            onClick={goAttendance}
                            disabled={!safeId(bootcamp)}
                        />
                    </div>
                </Col>
                <Col md={12}>
                    <DynamicTable
                        headers={table.columns}
                        data={table.rows}
                        customElements={table.customElements}
                        fullPage={true}
                        showLabel={false}
                        itemsPerPage={50}
                        loaderComponent={<Loader text="Cargando datos" />}
                        isLoading={isLoading}
                    />
                </Col>
            </Row>
        </ToolbarComponent>
    );
};

export default BootcampViewPage;


